import ServicesIcon from '@assets/icons/dashboard/categories/services.svg';
import DiyHouseholdStoresIcon from '@assets/icons/dashboard/categories/diyhouseholdstores.svg';
import AirlinesIcon from '@assets/icons/dashboard/categories/airlines.svg';
import CarHireIcon from '@assets/icons/dashboard/categories/carhire.svg';
import HotelsIcon from '@assets/icons/dashboard/categories/hotels.svg';
import TravelIcon from '@assets/icons/dashboard/categories/travel.svg';
import HealthIcon from '@assets/icons/dashboard/categories/health.svg';
import MotoringIcon from '@assets/icons/dashboard/categories/motoring.svg';
import CatalogueIcon from '@assets/icons/dashboard/categories/catalogue.svg';
import QuasiCashIcon from '@assets/icons/dashboard/categories/quasicash.svg';
import OtherRetailersIcon from '@assets/icons/dashboard/categories/otherretailers.svg';
import ClothingIcon from '@assets/icons/dashboard/categories/clothing.svg';
import PetrolIcon from '@assets/icons/dashboard/categories/petrol.svg';
import DepartmentStoresIcon from '@assets/icons/dashboard/categories/departmentstores.svg';
import SupermarketsIcon from '@assets/icons/dashboard/categories/supermarkets.svg';
import FoodDrinkIcon from '@assets/icons/dashboard/categories/fooddrink.svg';
import EntertainmentIcon from '@assets/icons/dashboard/categories/entertainment.svg';
import RecurringTransactionIcon from '@assets/icons/dashboard/categories/recurringtransaction.svg';
import ManualCashIcon from '@assets/icons/dashboard/categories/manualcash.svg';
import AtmCashIcon from '@assets/icons/dashboard/categories/atmcash.svg';
import ClosedLoopIcon from '@assets/icons/dashboard/categories/closedloop.svg';
import InternalIcon from '@assets/icons/dashboard/categories/internal.svg';
import HotelsAccommodationIcon from '@assets/icons/dashboard/categories/hotelsaccommodation.svg';
import LeisureEntertainmentIcon from '@assets/icons/dashboard/categories/leisureentertainment.svg';
import MarketplacesIcon from '@assets/icons/dashboard/categories/marketplaces.svg';

export const CATEGORY_ICONS = {
  services: <ServicesIcon />,
  diyhouseholdstores: <DiyHouseholdStoresIcon />,
  airlines: <AirlinesIcon />,
  carhire: <CarHireIcon />,
  hotels: <HotelsIcon />,
  travel: <TravelIcon />,
  health: <HealthIcon />,
  motoring: <MotoringIcon />,
  catalogue: <CatalogueIcon />,
  quasicash: <QuasiCashIcon />,
  otherretailers: <OtherRetailersIcon />,
  clothing: <ClothingIcon />,
  petrol: <PetrolIcon />,
  departmentstores: <DepartmentStoresIcon />,
  supermarkets: <SupermarketsIcon />,
  fooddrink: <FoodDrinkIcon />,
  entertainment: <EntertainmentIcon />,
  recurringtransaction: <RecurringTransactionIcon />,
  manualcash: <ManualCashIcon />,
  atmcash: <AtmCashIcon />,
  closedloop: <ClosedLoopIcon />,
  internal: <InternalIcon />,
  hotelsaccommodation: <HotelsAccommodationIcon />,
  leisureentertainment: <LeisureEntertainmentIcon />,
  marketplaces: <MarketplacesIcon />,
};
